import React, { useState, useEffect } from "react"
import { Dialog } from "primereact/dialog"
import "./cookieConsentBanner.scss"

const COOKIE_NAME = "cookie_consent_preferences"

const CookieConsentBanner = () => {
  const [visible, setVisible] = useState(false)
  const [showBanner, setShowBanner] = useState(false)
  const [preferences, setPreferences] = useState({
    analytics: true,
    advertisement: false,
    others: false,
  })

  useEffect(() => {
    const storedPrefs = localStorage.getItem(COOKIE_NAME)
    if (!storedPrefs) {
      setShowBanner(true)
    } else {
      const parsed = JSON.parse(storedPrefs)
      loadTrackingScripts(parsed)
    }
  }, [])

  useEffect(() => {
    visible
      ? (document.documentElement.style.overflow = "hidden")
      : (document.documentElement.style.overflow = "auto")
  }, [visible])

  const handleSave = () => {
    localStorage.setItem(COOKIE_NAME, JSON.stringify(preferences))
    loadTrackingScripts(preferences)
    setShowBanner(false)
  }

  const handleRejectAll = () => {
    setShowBanner(false)
    setVisible(false)
    localStorage.setItem(
      COOKIE_NAME,
      JSON.stringify({
        analytics: false,
        advertisement: false,
        others: false,
      })
    )
  }

  const handleAllSave = () => {
    localStorage.setItem(
      COOKIE_NAME,
      JSON.stringify({
        analytics: true,
        advertisement: true,
        others: true,
      })
    )
    loadTrackingScripts({
      analytics: true,
      advertisement: true,
      others: true,
    })
    setShowBanner(false)
  }

  const loadTrackingScripts = prefs => {
    if (prefs.analytics) {
      const ga4Script = document.createElement("script")
      ga4Script.src = `https://www.googletagmanager.com/gtag/js?id=${process.env.GA_MEASUREMENT_ID}`
      ga4Script.async = true
      document.head.appendChild(ga4Script)

      const uaScript = document.createElement("script")
      uaScript.src = `https://www.googletagmanager.com/gtag/js?id=${process.env.GA_TRACKING_ID}`
      uaScript.async = true
      document.head.appendChild(uaScript)

      uaScript.onload = () => {
        window.dataLayer = window.dataLayer || []
        function gtag() {
          window.dataLayer.push(arguments)
        }
        window.gtag = gtag
        gtag("js", new Date())
        gtag("config", process.env.GA_MEASUREMENT_ID)
        gtag("config", process.env.GA_TRACKING_ID)
      }

      const instantlyScript = document.createElement("script")
      instantlyScript.id = "vtag-ai-js"
      instantlyScript.async = true
      instantlyScript.src = "https://r2.leadsy.ai/tag.js"
      instantlyScript.setAttribute("data-pid", "UAVnAdOwdjx4dvCO")
      instantlyScript.setAttribute("data-version", "062024")
      document.head.appendChild(instantlyScript)
    }

    if (prefs.others) {
      const gtmScript = document.createElement("script")
      gtmScript.innerHTML = `
        (function(w,d,s,l,i){
          w[l]=w[l]||[];
          w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});
          var f=d.getElementsByTagName(s)[0],
              j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';
          j.async=true;
          j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
          f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','${process.env.GA_TAG_ID}');
      `
      const scriptTag = document.createElement("script")
      scriptTag.appendChild(document.createTextNode(gtmScript.innerHTML))
      document.head.appendChild(scriptTag)
    }

    if (prefs.advertisement) {
      //LinkedIn Pixel for advertising
      // Step 1: Inject _linkedin_partner_id script
      const idScript = document.createElement("script")
      idScript.type = "text/javascript"
      idScript.id = "linkedin-init-script"
      idScript.innerHTML = `
      _linkedin_partner_id = "6205756";
      window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
      window._linkedin_data_partner_ids.push(_linkedin_partner_id);
    `
      document.head.appendChild(idScript)

      // Step 2: Inject the function that initializes window.lintrk and adds the LinkedIn script
      const inlineInitScript = document.createElement("script")
      inlineInitScript.type = "text/javascript"
      inlineInitScript.innerHTML = `
      (function(l) {
        if (!l) {
          window.lintrk = function(a,b){window.lintrk.q.push([a,b])};
          window.lintrk.q = [];
        }
        var s = document.getElementsByTagName("script")[0];
        var b = document.createElement("script");
        b.type = "text/javascript";
        b.async = true;
        b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
        s.parentNode.insertBefore(b, s);
      })(window.lintrk);
    `
      document.head.appendChild(inlineInitScript)

      // Optional: Add noscript fallback image (not necessary for JS-only apps)
      const noscript = document.createElement("noscript")
      noscript.innerHTML = `
      <img height="1" width="1" style="display:none;" alt=""
           src="https://px.ads.linkedin.com/collect/?pid=6205756&fmt=gif" />
    `
      document.head.appendChild(noscript)

      //GTAG for Google Ads
      // 1. Inject Google gtag.js script
      const gtagScript = document.createElement("script")
      gtagScript.id = "google-gtag-script"
      gtagScript.async = true
      gtagScript.src =
        "https://www.googletagmanager.com/gtag/js?id=AW-956048293"
      document.head.appendChild(gtagScript)

      // 2. Inject gtag config script
      const gtagInit = document.createElement("script")
      gtagInit.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', 'AW-956048293');
      `
      document.head.appendChild(gtagInit)
    }
  }

  if (!showBanner) return null

  const footerButton = (
    <>
      <button className="save-preference-button" onClick={handleSave}>
        Save Preferences
      </button>
      <button className="reject-preference-button" onClick={handleRejectAll}>
        Reject All
      </button>
    </>
  )

  return (
    <>
      {!visible && (
        <div className="cookie-banner">
          <p>
            We use cookies to enhance your browsing experience and analyze
            website usage. We value your privacy. You can manage your cookie
            preferences below.
          </p>
          <div className="cookie-banner-buttons">
            <button className="accept-all-btn" onClick={handleAllSave}>
              Accept All
            </button>
            <button
              className="manage-preferences-btn"
              onClick={() => {
                setVisible(true)
              }}
            >
              <span>Manage Preferences</span>
            </button>
          </div>
        </div>
      )}
      <Dialog
        header="Customize Consent Preferences"
        visible={visible}
        draggable={false}
        className="cookie-policy-dialog"
        footer={footerButton}
        onHide={() => {
          if (!visible) return
          setVisible(false)
        }}
      >
        <div className="cookie-policy-wrapper">
          <div className="cookie-policy-content">
            <p>
              We use cookies to help you navigate efficiently and perform
              certain functions. You will find detailed information about all
              cookies under each consent category below.
            </p>
            {/* <p>
              The cookies that are categorized as "Necessary" are stored on your
              browser as they are essential for enabling the basic
              functionalities of the site.
            </p> */}
            <p>
              We also use third-party cookies that help us analyze how you use
              this website, store your preferences, and provide the content and
              advertisements that are relevant to you. These cookies will only
              be stored in your browser with your prior consent.
            </p>
            {/* <p>
              You can choose to enable or disable some or all of these cookies
              but disabling some of them may affect your browsing experience.
            </p> */}
          </div>
          <div className="cookie-policy-checkboxes">
            <div className="cookie-policy-checkboxes-wrapper">
              <div className="cookie-policy-checkboxes-header">
                <input
                  type="checkbox"
                  //   checked={preferences.analytics}
                  checked={true}
                  disabled
                  style={{ cursor: "not-allowed", opacity: 0.7 }}
                  onChange={e =>
                    setPreferences({
                      ...preferences,
                      analytics: true,
                    })
                  }
                />
                <p className="checkbox-title">Analytics</p>
              </div>
              <p className="checkbox-description">
                Analytical cookies are used to understand how visitors interact
                with the website. These cookies help provide information on
                metrics such as the number of visitors, bounce rate, traffic
                source, etc.
              </p>
            </div>
            <div className="cookie-policy-checkboxes-wrapper">
              <div className="cookie-policy-checkboxes-header">
                <input
                  type="checkbox"
                  checked={preferences.advertisement}
                  onChange={e =>
                    setPreferences({
                      ...preferences,
                      advertisement: e.target.checked,
                    })
                  }
                />
                <p className="checkbox-title">Advertisement</p>
              </div>
              <p className="checkbox-description">
                Advertisement cookies are used to provide visitors with
                customized advertisements based on the pages you visited
                previously and to analyze the effectiveness of the ad campaigns.
              </p>
            </div>
            <div className="cookie-policy-checkboxes-wrapper">
              <div className="cookie-policy-checkboxes-header">
                <input
                  type="checkbox"
                  checked={preferences.others}
                  onChange={e =>
                    setPreferences({
                      ...preferences,
                      others: e.target.checked,
                    })
                  }
                />
                <p className="checkbox-title">Others</p>
              </div>
              <p className="checkbox-description">
                Other uncategorized cookies are those that are being analyzed
                and have not been classified into a category as yet.
              </p>
            </div>
          </div>
        </div>
      </Dialog>
    </>
  )
}

export default CookieConsentBanner
